export default __webpack_public_path__ + "static/media/primary.e071fbbba0c8e46d580ddb10adab07a1.svg";